import React, {Component} from "react";
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component'
import { DATA_TYPE, MAX_LENGTH } from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";

class MobilityAll extends Component{
    constructor(props) {
        super(props);
        this.state={
            startDate:null
        }
    }

    render(){

        let decimalPlaceholder;

        if(this.props?.inputType === DATA_TYPE.decimal){
            decimalPlaceholder = "0.00";
        }
        return(
            <>
                
                 <DATEPICKER_OR
                    dateOnly={true}
                    label={this.props.Datelabel}
                    startDate={this.props.startDate ?  this.props.startDate : this.state.startDate}
                    selectedDate={(date) => this.props.selectedDate(date)}
                    placeholder={this.props.placeholder}
                    requiredField={true}
                />

                <InputField
                    className="form-control"
                    type="text"
                    label={this.props.InvoiceLabel}
                    value={this.props.invoiceNumber}
                    fieldProp='invoiceUploadForm.invoiceNumber'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={this.props.placeholderInvoiceNumber}
                    requiredField={true}
                />

                <InputField
                    className="form-control"
                    type="text"
                    label={this.props.CreditLabel}
                    value={this.props.invoiceUploadForm}
                    inputType={this.props?.inputType}
                    fieldProp='invoiceUploadForm.fanChargesAndCredits'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={decimalPlaceholder != null ? decimalPlaceholder : this.props.placeholderInvoiceNumber}
                    requiredField={true}
                    hasNegativeValue={true}
                />
            </>
        )
    }
}

export default MobilityAll;